import { cardList } from '@/api/card'
import { cities, shopBrands, shops } from '@/api/act'
import { allStation } from '@/api/site'

const state = {
  cards: [],
  cities: [],
  shops: [],
  brands: [],
  stations: [],
}

const mutations = {
  CHANGE_STATE: (state, value) => {
    Object.keys(value).map(key => {
      state[key] = value[key]
    })
  }
}

const actions = {
  changeCards({ commit }) {
    return new Promise(resolve => {
      cardList().then(list => {
        const cards = list.map(item => {
          item.quantity = 0
          item.discountAmount = -0.5
          item.defaultDisplay = item.cardAmount === 98000
          return item
        })
        commit('CHANGE_STATE', { cards })
        resolve(cards)
      })
    })
  },
  changeCities({ commit }) {
    return new Promise(resolve => {
      cities().then(cities => {
        commit('CHANGE_STATE', { cities })
        resolve(cities)
      })
    })
  },
  changeShops({ commit }) {
    return new Promise(resolve => {
      shops().then(shops => {
        commit('CHANGE_STATE', { shops })
        resolve(shops)
      })
    })
  },
  changeBrands({ commit }) {
    return new Promise(resolve => {
      shopBrands().then(brands => {
        commit('CHANGE_STATE', { brands })
        resolve(brands)
      })
    })
  },
  changeStations({ commit }) {
    return new Promise(resolve => {
      allStation({size: 10000}).then((data) => {
        const stations = data.list.map(item => {
          return {
            label: item.name + '(' + item.mobile + ')',
            key: item.stationId
          }
        })
        commit('CHANGE_STATE', { stations })
        resolve(stations)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
